<template>
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="formDisabled">
        <a-form-model ref="form" :model="model" :label-col="labelCol2" :wrapper-col="wrapperCol2"  :rules="validatorRules" slot="detail">
          <a-row>
             <a-col :span="12">
              <a-form-model-item :label="this.language['cs.activity.activitycode']"  prop="activitycode">
                <a-input v-model="model.activitycode" :placeholder="this.language['common.autosystemcode']"  disabled></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="this.language['cs.activity.activityname']"  prop="activityname">
                <a-input v-model="model.activityname" :placeholder="this.language['cs.activity.activityname']" maxLength="50"></a-input>
              </a-form-model-item>
            </a-col>
            
            <a-col :span="24">
              <a-form-model-item :label="this.language['cs.activity.startenddate']"  prop="startdate" :labelCol="labelCol1" :wrapperCol="wrapperCol1" >
                 <a-date-picker show-time :disabled-date="disabledDate" :placeholder="language['common.chooseStartDate']" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm"  class="query-group-cust" v-model="model.startdate"></a-date-picker>
                <span class="query-group-split-cust"></span>
                <a-date-picker show-time :disabled-date="disabledDate" :placeholder="language['common.chooseEndDate']" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm"  class="query-group-cust" v-model="model.enddate"></a-date-picker>
       
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="this.language['cs.activity.seatstartenddate']"  prop="seatstartdate" :labelCol="labelCol1" :wrapperCol="wrapperCol1" >
                 <a-date-picker show-time :disabled-date="disabledDate" :placeholder="language['common.chooseStartDate']" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm"  class="query-group-cust" v-model="model.seatstartdate"></a-date-picker>
                <span class="query-group-split-cust"></span>
                <a-date-picker show-time :disabled-date="disabledDate" :placeholder="language['common.chooseEndDate']" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm"  class="query-group-cust" v-model="model.seatenddate"></a-date-picker>
       
              </a-form-model-item>
            </a-col>
            
            <a-col :span="24">
              <a-form-model-item :label="this.language['cs.venue.venuename']" :labelCol="labelCol1"  :wrapperCol="wrapperCol1"  prop="sysvenueid">
                 <!-- <a-Select  v-model="model.sysvenueids" :options="selectVenueList" :disabled="operation.visible"  allow-clear  show-search optionFilterProp="children" 
               :placeholder="this.language['cs.venue.venuename']"  >
              </a-Select> -->
              <a-Select style="width: 200px;"  v-model="model.sysvenueid" :disabled="operation.visible"  :options="selectVenueList" allow-clear  show-search optionFilterProp="children" 
               :placeholder="this.language['cs.venue.venuename']"  >
              </a-Select>
              <span style="color: red;">場館一經選定無法修改</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="this.language['cs.activity.address']" :labelCol="labelCol1"  :wrapperCol="wrapperCol1" prop="address">
                <a-input v-model="model.address" :placeholder="this.language['cs.activity.address']" maxLength="150"></a-input>
              </a-form-model-item>
            </a-col>
          <a-col :span="24" >
            <a-form-model-item :labelCol="labelCol1" :wrapperCol="wrapperCol1" :label="this.language['cs.activity.photoinfo']"  prop="activityfiles">
                <j-image-upload class="avatar-uploader" text="上传" :upload-source="uploadSource" v-model="model.activityfiles" :isMultiple="true" :disabled="disableSubmit"></j-image-upload>
           </a-form-model-item>
          </a-col>
            <a-col :span="24">
              <a-form-model-item :label="this.language['cs.activity.remark']" :labelCol="labelCol1"  :wrapperCol="wrapperCol1" prop="remark">
                <j-editor v-model="model.remark"  :placeholder="this.language['cs.activity.remark']" ></j-editor>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </template>
  
  
  <script>
  
  import {validateDuplicateValue} from '@/utils/util'
  import { httpAction, getAction } from '@/api/manageChooseSeat'
  import moment from 'moment'
  
  export default {
    name: 'ActivityForm',
    inject:['operation'],
    components: {},
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        model: {sysvenueidlist:[],},
        uploadSource:"chooseseat",
      // form 一行布局
      labelCol1: { span: 4 },
      wrapperCol1: { span: 18 },
      // form 两行布局， 默认为两行
      labelCol2: { span: 8 },
      wrapperCol2: { span: 12 },
      confirmLoading: false,
        url: {
          add: "/ActivityInfo/addData",
          edit: "/ActivityInfo/editData"
        },
        selectVenueList:[],
       
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      formDisabled() {
        return this.disabled
      },
      validatorRules() {
        if (this.language) {
          return {
            activityname: [
              {required: true, message: this.language['cs.input']+this.language['cs.activity.activityname']+'!'}
            ],
            // sysvenueidlist: [
            //   {required: true, message: this.language['cs.select']+this.language['cs.venue.venuename']+'!'}
            // ],
            sysvenueid: [
              {required: true, message: this.language['cs.select']+this.language['cs.venue.venuename']+'!'}
            ],
            startdate: [
              {required: true, message: this.language['cs.select']+this.language['cs.activity.seatstartenddate']+'!'}
            ], 
            enddate: [
              {required: true, message: this.language['cs.select']+this.language['cs.activity.seatstartenddate']+'!'}
            ],
            seatstartdate: [
              {required: true, message: this.language['cs.select']+this.language['cs.activity.seatstartenddate']+'!'}
            ],
            seatenddate: [
              {required: true, message: this.language['cs.select']+this.language['cs.activity.seatstartenddate']+'!'}
            ]

          }
        }
      }
  
    },
    created() {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
     this.loadSelectData();
    },
    mounted(){
    
      },
      watch: {
    },
    methods: {
      loadSelectData() { 
          this.selectVenueList=null;  
          let selectvenue= { keytype: "venue", parentid:"",curvalue:this.model.sysvenueids};  
           getAction('/SelectData/SelectDataList', selectvenue).then((res) => {
          if (res.success) {
            this.selectVenueList= res.result.records;
          }
      });  
      },
      disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().subtract(1, 'days').endOf('day')
    },
   

      add() {
        this.edit(this.modelDefault);
      },
      edit(record) {
        this.model = Object.assign({}, record);
        if(this.operation.optiontype!='add')
        {
          this.model.sysvenueid=this.model.sysvenueidlist[0];
        }
      
        this.visible = true;
      },
     
      submitForm() {
        const that = this;
        that.model.sysvenueidlist=[];
       // alert(this.model.enddate)
        if(that.model.enddate=="" ||that.model.enddate==null ||that.model.enddate=="undefined"  )
        {
          that.$message.warning(that.language['cs.select']+that.language['cs.activity.startenddate']);
          return;
        }
        if(that.model.seatenddate==""||that.model.seatenddate==null ||that.model.seatenddate=="undefined" )
        {
          that.$message.warning(that.language['cs.select']+that.language['cs.activity.seatstartenddate']);
          return;
        }
        if(that.model.enddate<that.model.startdate|| that.model.seatenddate<that.model.seatstartdate)
        {
          that.$message.warning("日期起止時間不合法 ");
          return;

        }
        if(that.model.seatstartdate<that.model.startdate|| that.model.seatstartdate>that.model.enddate)
        {
          that.$message.warning("选座日期起止時間不合法 ");
          return;

        }
        if(that.model.seatenddate<that.model.startdate|| that.model.seatenddate>that.model.enddate)
        {
          that.$message.warning("选座日期起止時間不合法 ");
          return;

        }
        const imgReg = /<img.*?(?:>|\/>)/gi
        const videoReg = /<video.*?(?:>|\/>)/gi
        const imgs = that.model.remark.match(imgReg)
        const videos = that.model.remark.match(videoReg)
          let content = that.model.remark.replace(/<[^>]+>/ig, '')
          content = content.replace(/&nbsp;/ig, '').trim()
        if(content!=null&&content.length>500 )
        {
          that.$message.warning("活动内容超长");
          return;

        }
        that.model.sysvenueidlist.push(that.model.sysvenueid);
       
        // 触发表单验证
        that.$refs.form.validate(valid => {
  
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!that.model.sysactivityid) {
              httpurl += that.url.add;
              method = 'post';
            } else {
              httpurl += that.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
  
        })
      },
   
    }
  }
  
  
  </script>